import { useAccountClaimAnalyticsParams } from "core/analytics/analytics.hooks";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

export const useInitGoogleAnalytics = () => {
  const gaMeasurementId = window.appConfig.gtmId;

  const { userId } = useAccountClaimAnalyticsParams();

  if (!ReactGA.isInitialized && gaMeasurementId) {
    ReactGA.initialize(gaMeasurementId, {
      gaOptions: {
        userId
      }
    });
  }
};

export const useGoogleAnalyticsPageTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", pageLocation: pathname });
  }, [pathname]);
};
